import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/flag': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M336.2 80C287 80 242.9 48 174.3 48 143 48 116 54.5 93.5 63.2A48-48 0 0 1 95.7 42.4C93.1 19.6 74.2 1.6 51.2 0.1 23.2-1.7 0 20.4 0 48 0 65.8 9.7 81.3 24 89.6V496C24 504.8 31.2 512 40 512H56C64.8 512 72 504.8 72 496V412.6C109.9 395.3 143.3 384 199.8 384 249 384 293.1 416 361.7 416 420.2 416 463.7 393.4 490.3 376 503.8 367.2 512 352.1 512 335.9V95.9C512 61.5 476.7 38.2 445.1 51.8 409.2 67.3 371.6 80 336.2 80zM464 336C442.2 351.4 403.2 368 361.7 368 301.8 368 259.7 336 199.8 336 156.5 336 103.4 345.4 72 360V128C93.8 112.6 132.8 96 174.3 96 234.2 96 276.3 128 336.2 128 379.4 128 432.5 110.6 464 96V336z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/flag.js
// module id = 1nrp
// module chunks = 144